import {AppComponent} from './app/app.component';
import {NgOptimizedImage, registerLocaleData} from '@angular/common';
import {MonacoEditorModule} from 'ngx-monaco-editor-v2';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatCardModule} from '@angular/material/card';
import {TranslocoHttpLoader} from './app/transloco-root.module';
import {provideTransloco} from '@jsverse/transloco';
import {MatRadioModule} from '@angular/material/radio';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatListModule} from '@angular/material/list';
import {MatSidenavModule} from '@angular/material/sidenav';
import {provideAnimations} from '@angular/platform-browser/animations';
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser';
import {GlobalErrorHandler} from './app/shared/helpers/global-error-handler';
import {ErrorHandler, importProvidersFrom, isDevMode, LOCALE_ID, provideAppInitializer, inject} from '@angular/core';
import {PerformanceMonitoringService} from '@angular/fire/compat/performance';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {AuthService} from './app/shared/services/auth.service';
import {FIREBASE_OPTIONS} from "@angular/fire/compat";
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {getFirestore, provideFirestore} from '@angular/fire/firestore';
import {provideAuth, getAuth} from "@angular/fire/auth";
import {getDatabase, provideDatabase} from "@angular/fire/database";
import {providePerformance, getPerformance} from "@angular/fire/performance";
import {provideStorage, getStorage} from "@angular/fire/storage";
import {getFunctions, provideFunctions} from "@angular/fire/functions";
import localeDe from '@angular/common/locales/de';
import {provideRouter, RouteReuseStrategy, withInMemoryScrolling} from "@angular/router";
import {routes} from "./app/app-routing.module";
import {TicketsRouteReuseStrategy} from "./app/shared/helpers/tickets-route-reuse-strategy";
import {FirebaseService} from "./app/shared/services/firebase.service";
import {provideLottieOptions} from "ngx-lottie";
import {logger} from './app/shared/services/logging.service';
import {TranslocoService} from '@jsverse/transloco';
import {firstValueFrom} from 'rxjs';

registerLocaleData(localeDe);

(self as any).MonacoEnvironment = {
    getWorkerUrl: function () {
        return '/assets/monaco/min/vs/base/worker/workerMain.js';
    }
};

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, MatSidenavModule,
            MatListModule, MatToolbarModule, MatIconModule, MatButtonModule, MatSelectModule, FormsModule, MatTableModule,
            MatSortModule, MatProgressSpinnerModule,
            MatMenuModule, MatInputModule, MatDialogModule,
            MatNativeDateModule, ReactiveFormsModule, MatSnackBarModule, MatButtonToggleModule,
            MatProgressBarModule, MatRadioModule, MatCardModule,
            MatDatepickerModule, NgxChartsModule, MonacoEditorModule.forRoot(), NgOptimizedImage),
        AuthService, MatSnackBarModule, PerformanceMonitoringService,
        provideTransloco({
            config: {
                availableLangs: ['en', 'de'],
                defaultLang: 'en',
                reRenderOnLangChange: true,
                prodMode: !isDevMode(),
            },
            loader: TranslocoHttpLoader
        }),
        provideAppInitializer(() => firstValueFrom(inject(TranslocoService).load('en'))),
        provideAppInitializer(() => firstValueFrom(inject(TranslocoService).load('de'))),
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        },
        { provide: LOCALE_ID, useValue: 'de-DE' },
        { provide: FIREBASE_OPTIONS, useValue: FirebaseService.getEnvironment()},
        provideAnimations(),
        provideLottieOptions({
            player: () => import('lottie-web')
        }),
        provideRouter(routes,
            withInMemoryScrolling({
                scrollPositionRestoration: 'enabled',
            })),
        {provide: RouteReuseStrategy, useClass: TicketsRouteReuseStrategy},
        provideHttpClient(withInterceptorsFromDi()),
        provideFirebaseApp(() => initializeApp(FirebaseService.getEnvironment())),
        provideStorage(() => getStorage()),
        provideFirestore(() => getFirestore()),
        provideAuth(() => getAuth()),
        provideDatabase(() => getDatabase()),
        providePerformance(() => getPerformance()),
        provideFunctions(() => getFunctions())
    ]
})
  .catch(err => logger.error(err));
